(() => {
  const dialog = document.getElementById('kf-notify-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const variants = dialog.querySelector('select');
  const email = dialog.querySelector('[name="email"]');
  const phone = dialog.querySelector('[name="phone"]');
  const submit = dialog.querySelector('[type="submit"]');
  const close = dialog.querySelector('.kf-notify-close');
  const status = dialog.querySelector('.kf-notify-status');
  const copy = {
    de: { waiting: 'Wird gespeichert …', success: 'Du bist eingetragen. Wir benachrichtigen dich, wenn deine Größe verfügbar ist.', error: 'Das hat leider nicht geklappt. Bitte versuche es erneut.', phone: 'Bitte gib deine Mobilnummer mit Ländervorwahl ein, z. B. +49 151 23456789.', smsNotice: 'Wir verwenden deine Mobilnummer, um dich per SMS über die Verfügbarkeit dieses Produkts zu informieren.' },
    en: { waiting: 'Saving …', success: 'You’re on the list. We’ll let you know if your size becomes available.', error: 'Something went wrong. Please try again.', phone: 'Enter your mobile number with country code, e.g. +44 7700 900123.', smsNotice: 'We use your mobile number to notify you by SMS about the availability of this product.' },
    fr: { waiting: 'Enregistrement …', success: 'Tu es inscrit. Nous te préviendrons si ta taille devient disponible.', error: 'Une erreur est survenue. Réessaie.', phone: 'Saisis ton numéro avec l’indicatif international, par ex. +33 6 12 34 56 78.', smsNotice: 'Nous utilisons ton numéro de mobile pour t’informer par SMS de la disponibilité de ce produit.' },
    nl: { waiting: 'Wordt opgeslagen …', success: 'Je staat op de lijst. We laten het je weten als je maat beschikbaar komt.', error: 'Er ging iets mis. Probeer het opnieuw.', phone: 'Vul je mobiele nummer met landcode in, bijvoorbeeld +31 6 12345678.', smsNotice: 'We gebruiken je mobiele nummer om je per sms te informeren over de beschikbaarheid van dit product.' }
  }[dialog.dataset.locale] || { waiting: 'Saving …', success: 'You’re on the list.', error: 'Something went wrong. Please try again.', phone: 'Include your country code.', smsNotice: 'We use your mobile number to notify you about this product.' };
  const notice = dialog.querySelector('.kf-notify-notice');
  const emailNotice = notice.textContent;
  const originalSubmit = submit.textContent;
  const productId = Number(dialog.dataset.productId);
  let channel = 'email';
  let pending = false;
  let completed = false;
  let opener;
  let previousOverflow;

  function setStatus(message) {
    status.textContent = message;
    status.hidden = !message;
  }
  function setPending(value) {
    pending = value;
    form.setAttribute('aria-busy', String(value));
    submit.disabled = value || completed;
    variants.disabled = value;
    dialog.querySelectorAll('[data-channel]').forEach(button => { button.disabled = value; });
    email.readOnly = value;
    phone.readOnly = value;
    submit.textContent = value ? copy.waiting : originalSubmit;
  }
  function normalizePhone() { return phone.value.replace(/[\s().-]/g, ''); }
  function validatePhone() {
    phone.setCustomValidity(channel === 'sms' && !/^\+[1-9]\d{6,14}$/.test(normalizePhone()) ? copy.phone : '');
  }
  phone.addEventListener('input', validatePhone);
  dialog.querySelectorAll('[data-channel]').forEach(button => {
    button.addEventListener('click', () => {
      if (pending || completed) return;
      channel = button.dataset.channel;
      dialog.querySelectorAll('[data-channel]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
      dialog.querySelectorAll('[data-contact]').forEach(panel => { panel.hidden = panel.dataset.contact !== channel; });
      email.disabled = channel !== 'email';
      email.required = channel === 'email';
      phone.disabled = channel !== 'sms';
      phone.required = channel === 'sms';
      notice.textContent = channel === 'email' ? emailNotice : copy.smsNotice;
      validatePhone();
      setStatus('');
      (channel === 'email' ? email : phone).focus();
    });
  });
  function resetResult() {
    completed = false;
    submit.disabled = false;
    setStatus('');
  }
  variants.addEventListener('change', resetResult);
  email.addEventListener('input', resetResult);
  phone.addEventListener('input', resetResult);

  dialog.kfOpen = (variantId) => {
    if (!variants.options.length || typeof window.BIS?.create !== 'function') return false;
    if (!pending) {
      const selected = [...variants.options].find(option => option.value === String(variantId));
      variants.value = (selected || variants.options[0]).value;
      resetResult();
    }
    opener = document.activeElement;
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
    dialog.querySelector('h2').focus({ preventScroll: true });
    return true;
  };
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (pending || completed) return;
    validatePhone();
    if (!form.reportValidity()) return;
    const variantId = Number(variants.value);
    if (!productId || !variantId || ![...variants.options].some(option => Number(option.value) === variantId) || typeof window.BIS?.create !== 'function') {
      setStatus(copy.error);
      return;
    }
    setPending(true);
    setStatus('');
    try {
      // The existing app remains the recipient. Do not opt customers into marketing.
      const request = channel === 'sms'
        ? window.BIS.create(null, variantId, productId, { phone_number: normalizePhone() })
        : window.BIS.create(email.value.trim(), variantId, productId);
      request.then(response => {
        if (response?.status === 'OK') {
          completed = true;
          setStatus(response.message || copy.success);
        } else {
          const errors = response?.errors ? Object.values(response.errors).flat().join(' ') : '';
          setStatus(errors || copy.error);
        }
        setPending(false);
      });
    } catch (_) {
      setPending(false);
      setStatus(copy.error);
    }
  });
})();
